import cloneDeep from 'lodash/cloneDeep';
import each from 'lodash/each';

import { SET_ORGANIZER_ARTICLES, FOLLOW_ORGANIZER } from './actionTypes';

export const fiveToFollow = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === SET_ORGANIZER_ARTICLES) {
        nextState = payload;
    }

    if (type === FOLLOW_ORGANIZER) {
        const buckets = cloneDeep(state);

        each(buckets, (bucket) => {
            each(bucket.organizerArticles, (organizerArticle) => {
                if (organizerArticle.id === payload.id) {
                    // eslint-disable-next-line no-param-reassign
                    organizerArticle.followedByYou = payload.value;
                }
            });
        });

        nextState = buckets;
    }

    return nextState;
};
